<script>
  export let voteLabel = 'total';
  /** @type {boolean} */
  export let isBallotMeasure
  // /** @type {boolean} */
  // export let hasParties
  /** @type {boolean} */
  export let face

</script>

<thead>
  <tr>

      <th scope="col" colSpan={1} class="contest__candidate-header"></th>

    <th scope="col" colSpan={face ? 2 : 1} class="contest__candidate-header">
      {isBallotMeasure ? 'Support' : 'Candidate'}
    </th>
    <th scope="col" class="contest__candidate-header text-left">
      <span>% votes</span>
    </th>
    <th scope="col" class="contest__candidate-header text-right">
      {voteLabel}
    </th>
  </tr>
</thead>
